<template>
  <div>
    <TimeSlotsEditModal
      v-if="timeSlotsEditModalMode !== 'none'"
      :initialTimeSlotData="editTimeSlotData"
      :mode="timeSlotsEditModalMode"
      @close="args => changeTimeSlot(args)"
    />
    <CModal v-model="day.id" title="Are you sure to delete selected day?" color="danger" :show.sync="showDeleteDayModal"
      @update:show="closeDeleteModal">
      <CRow>
        <CCol col="6">
          <CInput label="Name" v-model="experienceDay.name" disabled />
        </CCol>
        <CCol col="6">
          <CInput label="Order" v-model="experienceDay.order" disabled />
        </CCol>
        <CCol col="12">
          <CInput label="Description" v-model="experienceDay.description" disabled />
        </CCol>
      </CRow>
    </CModal>

    <CModal title="Are you sure to delete selected row?" color="danger" :show.sync="showDeleteRowModal"
      @update:show="closeDeleteRowModal"></CModal>

    <CModal v-model="experienceSchedule.id" :title="dayModalMode === 'edit' ? 'Edit day' : 'Add new day'" color="primary"
      :show.sync="showDayModal" @update:show="closeDayModal">
      <CRow>
        <CCol col="6">
          <CInput label="Name" v-model="experienceDay.name" />
        </CCol>
        <CCol col="6">
          <CInput label="Order" v-model="experienceDay.order" />
        </CCol>
        <CCol col="12">
          <CInput label="Description" v-model="experienceDay.description" />
        </CCol>
      </CRow>
    </CModal>

    <CModal title="Add Experience Row" :show="!!editDayId"
      @update:show="(_, event, accept) => modalAction(_, event, accept)">
      <CRow>
        <CCol col="12">
          <CSelect label="Experience type" :options="expRowOptions" @update:value="e => chooseExpType(e)" />
        </CCol>
      </CRow>
      <CRow>
        <CCol col="12">
          <CSelect v-if="chosenNewExpType == externalIntegrationString" label="External Integration"
            :options="integrations" @update:value="e => chooseIntegration(e)" />
        </CCol>
      </CRow>
    </CModal>
    <CAlert :color="alertType" v-if="message" fade>
      {{ message }}
    </CAlert>
    <h3>
      <CIcon name="cil-mood-very-good"></CIcon>
      Experience Schedule
    </h3>
    <CForm @submit.prevent="create" method="POST">
      <b-tabs content-class="mt-3">
        <b-tab title="General" active>
          <template>
            <CRow>
              <CCol style="margin-left:30px">
                <h4>
                  <CIcon name="cil-list" style="margin-bottom: 5px" class="text-primary"></CIcon>
                  General
                </h4>
              </CCol>
              <CCol class="text-right" style="margin-right:15px;">
                <div><label>Active</label></div>
                <CSwitch color="success" size="lg" :checked.sync="experienceSchedule.active"></CSwitch>
              </CCol>
            </CRow>

            <CRow style="margin-left:30px">
              <CCol col="6" style="min-width: 10rem;">
                <label>From</label>
                <DatePickerComponent v-model="experienceSchedule.startTime" :format="$dateFormatInput.split(' ')[0]"></DatePickerComponent>
              </CCol>
              <CCol col="6" style="min-width: 7rem; margin-right:5px">
                <label>To</label>
                <DatePickerComponent v-model="experienceSchedule.endTime" :format="$dateFormatInput.split(' ')[0]"></DatePickerComponent>
              </CCol>
            </CRow>
            <CRow style="margin-left:30px">
              <CCol style="min-width: 10rem;">
                <label style="width: 100%">Name
                  <a @click="toggleNameTranslations = !toggleNameTranslations">
                    <CIcon name="cil-globe-alt" style="margin-bottom: 5px" class="text-primary"></CIcon>
                  </a>
                </label>

                <div class="form-group">
                  <div class="input-group" v-if="experienceSchedule.nameTranslations[0]" v-show="!toggleNameTranslations">
                    <div class="input-group-prepend">
                      <span v-text="experienceSchedule.nameTranslations[0].languageCode" class="input-group-text"
                        v-show="!toggleNameTranslations" />
                    </div>
                    <input id="name" name="name" type="text" class="form-control"
                      v-model="experienceSchedule.nameTranslations[0].name" />
                  </div>
                </div>
                <div class="form-group" v-show="toggleNameTranslations"
                  v-for="(language, k) in experienceSchedule.nameTranslations" :key="k">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span v-text="language.languageCode" class="input-group-text" />
                    </div>
                    <input type="text" class="form-control" @id="language.languageCode"
                      v-model="experienceSchedule.nameTranslations[k].name" />
                  </div>
                </div>
              </CCol>
              <CCol>
                <CInput label="Priority" type="text" v-model="experienceSchedule.priority"></CInput>
              </CCol>
            </CRow>

            <CRow style="margin-left:30px">
              <CCol style="min-width: 10rem;">
                <label style="width: 95%">Starting from price
                  <a @click="toggleStartingPriceTranslations = !toggleStartingPriceTranslations">
                    <CIcon name="cil-globe-alt" style="margin-bottom: 5px" class="text-primary"></CIcon>
                  </a>
                </label>

                <div class="form-group">
                  <div class="input-group" v-if="experienceSchedule.startingPriceTranslations[0]"
                    v-show="!toggleStartingPriceTranslations">
                    <div class="input-group-prepend">
                      <span v-text="experienceSchedule.startingPriceTranslations[0].languageCode" class="input-group-text"
                        v-show="!toggleStartingPriceTranslations" />
                    </div>
                    <input id="name" name="name" type="text" class="form-control"
                      v-model="experienceSchedule.startingPriceTranslations[0].name" />
                  </div>
                </div>
                <div class="form-group" v-show="toggleStartingPriceTranslations"
                  v-for="(language, k) in experienceSchedule.startingPriceTranslations" :key="k">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span v-text="language.languageCode" class="input-group-text" />
                    </div>
                    <input type="text" class="form-control" @id="language.languageCode"
                      v-model="experienceSchedule.startingPriceTranslations[k].name" />
                  </div>
                </div>
              </CCol>
            </CRow>
            <CRow style="margin-left: 2rem;">
              <CCol col="12">
                Type
              </CCol>
            </CRow>
            <CRow style="margin-left:2rem; margin-top: .5rem;">
              <CInputRadio label="Date range (days)" type="radio" name="types"
                :checked="experienceSchedule.timeSelection === 3" @change="experienceSchedule.timeSelection = 3"
                style="margin-left: 1rem;" />
              <CInputRadio label="Date range (nights)" type="radio" name="types"
                :checked="experienceSchedule.timeSelection === 4" @change="experienceSchedule.timeSelection = 4"
                style="margin-left: 1rem;" />

              <CInputRadio label="Departure / Single day" type="radio" name="types"
                :checked="experienceSchedule.timeSelection === 2" @change="experienceSchedule.timeSelection = 2"
                style="margin-left: 1rem;" />
              <CInputRadio label="Timeslot" type="radio" name="types" :checked="experienceSchedule.timeSelection === 1"
                @change="experienceSchedule.timeSelection = 1" style="margin-left: 1rem;" />
            </CRow>
            <CRow v-if="isDataLoaded">
              <CCol>
                <div style="padding: 1rem; margin-left: 2rem; margin-top: 1rem;">
                  <h4>
                    <CIcon name="cil-calendar" style="margin-bottom: 5px" class="text-primary"></CIcon>
                    {{ experienceSchedule.timeSelection === 1 ? 'Timeslots' : 'Availability Start Day' }}
                  </h4>
                  <div v-if="experienceSchedule.timeSelection === 1">
                    <TimeSlots
                      :timeSlots="experienceSchedule.availability"
                      @edittimeslot="timeSlot => openEditTimeslot(timeSlot, 'edit')"
                      @deletetimeslot="timeSlot => openEditTimeslot(timeSlot, 'delete')"
                    />
                  </div>
                  <div v-else style="display: flex; flex-wrap: wrap;">
                    <div v-for="day of Object.keys(selectedStartDays)" :key="day" class="form-check" style="padding-left: 0; margin-right: 2rem;">
                      <div>
                        <input :id="`availabilityStartInput-${day}`" v-model="selectedStartDays[day]" name="weekDay" type="checkbox" style="accent-color:#321fdb" />
                        <label :for="`availabilityStartInput-${day}`" style="padding-left: .5rem; margin-bottom: 0;">{{ getWeekdayName(day) }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </CCol>
            </CRow>
          </template>
        </b-tab>
        <b-tab title="Duration and Limits">
          <CRow style="margin-left: 1rem;">
            <CCol style="border-left: 1px solid lightgrey; margin-left: 1rem; padding-left: 2rem;">
              <h4>
                <CIcon name="cil-calendar"></CIcon> Duration and Day Limits
              </h4>
              <CRow style="align-items: flex-end;">
                <CCol v-if="experienceSchedule.duration" col="3"
                  style="width: 15rem; min-width: 15rem; max-width: 15rem;">
                  <CInput label="Days" v-model="experienceSchedule.duration.days" type="text"
                    style="width: 3rem; display: inline-block;" />
                  <CInput label="Hours" v-model="experienceSchedule.duration.hours" type="text"
                    style="width: 3rem; display: inline-block; margin-left: 1rem;" />
                  <CInput label="Minutes" v-model="experienceSchedule.duration.minutes" type="text"
                    style="width: 3rem; display: inline-block; margin-left: 1rem;" />
                </CCol>
                <CCol v-if="experienceSchedule.timeSelection === 3 || experienceSchedule.timeSelection === 4">
                  <CInput label="Min. length (days)" v-model="experienceSchedule.limit.minDays"
                    style="width: 6rem; display: inline-block; margin-left: 1rem;" />
                  <CInput label="Max. length (days)" v-model="experienceSchedule.limit.maxDays"
                    style="width: 6rem; display: inline-block; margin-left: 1rem;" />
                </CCol>
              </CRow>
              <CRow style="align-items: flex-start;">
                <CCol v-if="experienceSchedule.bookingCutoff" style="width: 15rem; min-width: 15rem; max-width: 15rem;">
                  <h4>
                    <CIcon name="cil-clock" /> Cutoff
                  </h4>
                  <CInput type="text" label="Days" v-model="experienceSchedule.bookingCutoff.days"
                    style="width: 3rem; display: inline-block;" />
                  <CInput type="text" label="Hours" v-model="experienceSchedule.bookingCutoff.hours"
                    style="width: 3rem; display: inline-block; margin-left: 1rem;" />
                  <CInput type="text" label="Minutes" v-model="experienceSchedule.bookingCutoff.minutes"
                    style="width: 3rem; display: inline-block; margin-left: 1rem;" />
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </b-tab>
        <b-tab title="Capacity">
          <CRow style="margin-left:15px">
            <CCol>
              <h4>
                <CIcon name="cil-user" class="text-primary"></CIcon> Capacity
              </h4>
            </CCol>
          </CRow>
          <CRow style="margin-left:15px">
            <CCol>
              <span>Per booking</span>
              <CRow>
                <CCol col="2"></CCol>
                <CCol col="2">Disabled</CCol>
                <CCol col="2">Min</CCol>
                <CCol col="2">Max</CCol>
              </CRow>
              <CRow v-for="expRowCapac in experienceSchedule.perBookingCapacity.guestTypeSpecificCapac" :key="expRowCapac.guestTypeId">
                <CCol col="2">
                  <span>{{ expRowCapac?.label }}</span>
                </CCol>
                <CCol col="2">
                  <input v-model="expRowCapac.disabled" type="checkbox" />
                </CCol>
                <CCol col="2">
                  <CInput v-model="expRowCapac.min" />
                </CCol>
                <CCol col="2">
                  <CInput v-model="expRowCapac.max" />
                </CCol>
              </CRow>
              <CRow>
                <CCol col="2">
                  <span>Total</span>
                </CCol>
                <CCol col="2">

                </CCol>
                <CCol col="2">
                  <CInput v-model="experienceSchedule.perBookingCapacity.minTotal" />
                </CCol>
                <CCol col="2">
                  <CInput v-model="experienceSchedule.perBookingCapacity.maxTotal" />
                </CCol>
              </CRow>
            </CCol>
            <CCol>
              <span>Per departure</span>
              <CRow>
                <CCol col="2">Min</CCol>
                <CCol col="2">Max</CCol>
                <CCol col="2">Bookings</CCol>
              </CRow>
              <CRow v-for="perItemCapac in experienceSchedule.perDepartureCapacity.guestTypeSpecificCapac" :key="perItemCapac.guestTypeId">
                <CCol col="2">
                  <CInput v-model="perItemCapac.min" />
                </CCol>
                <CCol col="2">
                  <CInput v-model="perItemCapac.max" />
                </CCol>
              </CRow>
              <CRow>
                <CCol col="2">
                  <CInput v-model="experienceSchedule.perDepartureCapacity.minTotal" />
                </CCol>
                <CCol col="2">
                  <CInput v-model="experienceSchedule.perDepartureCapacity.maxTotal" />
                </CCol>
                <CCol col="2">
                  <CInput v-model="experienceSchedule.perDepartureCapacity.bookings" />
                </CCol>
              </CRow>

            </CCol>
          </CRow>
        </b-tab>
      </b-tabs>
      <CCard>
        <CCardBody>


          <CRow style="padding-top: 40px">
            <CCol col="8"></CCol>
            <CCol class="d-flex justify-content-end">
              <CButton color="secondary" class="btn-lg" @click="goBack">
                <CIcon name="cil-mood-very-good" /> Back to experience
              </CButton>
              <CButton type="submit" color="primary" style="margin-left: 15px" class="btn-lg">
                <CIcon name="cil-save" /> Save
              </CButton>
              <div v-if="experienceSchedule.timeSelection === 1">
                <CButton @click="openAddTimeslot()" class="btn-lg" color="secondary" style="margin-left: 15px">
                  <CIcon name="cil-plus" /> Add slot
                </CButton>
              </div>

            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CForm>
    <CCard v-if="experienceSchedule.id != emptyGuid">
      <CCardBody>
        <CRow>
          <CCol col="9">
            <h5>Daily Breakdown</h5>
          </CCol>
          <CCol col="3" class="text-right">
            <CButton color="secondary" class="btn text-primary" @click="showDayModal = true; dayModalMode = 'add'">
              <CIcon name="cil-plus" /> Add day
            </CButton>
          </CCol>
        </CRow>
        <br />
        <br />
        <CRow v-for="day of items" :key="day.id" style="flex-direction: column; margin-left: 1rem; margin-right: 1rem;">
          <CRow
            style="flex-direction: row; align-items: center; justify-content: space-between; background-color: #768192; color: white; padding: 5px 10px;">
            <div>
              <span style="font-weight: bold; display: inline-block; min-width: 15rem;">{{ day.title }}</span>
              <CButton color="primary" @click="showDayModal = true; experienceDay = day; dayModalMode = 'edit';"
                style="margin-left: 1rem;">
                <CIcon name="cil-pencil" /> Edit
              </CButton>
              <CButton color="danger" @click="showDeleteDayModal = true; experienceDay = day;" style="margin-left: 1rem;">
                <CIcon name="cil-trash" /> Delete
              </CButton>
              <CButton color="secondary" @click="openExpRowAddModal(day.id)" class="btn text-primary"
                style="margin-left: 1rem;">
                <CIcon name="cil-plus" /> Add experience row
              </CButton>
            </div>
            <a @click="toggle(day.id)">
              <CIcon name="cil-chevron-bottom" style="cursor: pointer;"
                :style="itemsVisibility[day.id] ? 'transform: rotate(180deg);' : ''" />
            </a>
          </CRow>
          <CRow>
            <CCollapse :show="itemsVisibility[day.id]" :key="day.id">
              <CDataTable :items="day.experienceRows" :fields="rowfields" v-if="day.experienceRows.length > 0"
                style="width: -webkit-fill-available;">
                <template #Source="{ item }">
                  <td style="width: 7em;">
                    <span v-if="item.sourceType == 0">Inventory</span>
                    <span v-else-if="item.sourceType == 1">Partner Experience</span>
                    <span v-else-if="item.sourceType == 2">External Integration</span>
                  </td>
                </template>
                <template #Resource="{ item }">
                  <td>
                    <span v-if="item.inventory != null">{{ item.inventory.name }}</span>
                  </td>
                </template>
                <template #Visibility="{ item }">
                  <td>
                    <CBadge :color="getVisibilityBadge(item.type)">
                      <span v-if="item.type == 0">Row</span>
                      <span v-else-if="item.type == 1">Add-on</span>
                      <span v-else-if="item.type == 3">Option</span>
                      <span v-else>Hidden</span>
                    </CBadge>
                  </td>
                </template>
                <template #status="{ item }">
                  <td>
                    <CBadge :color="getStatusBadge(item.active)">
                      {{ item.active == true ? "Active" : "Inactive" }}
                    </CBadge>
                  </td>
                </template>
                <template #sortOrder="{ item }">
                  <td>
                    {{ item.sortOrder }}
                  </td>
                </template>
                <template #Edit="{ item }">
                  <td>
                    <CButton color="primary" @click="editExperienceRow(day.id, item.id)">
                      <CIcon name="cil-pencil" /> Edit
                    </CButton>
                  </td>
                </template>
                <template #Delete="{ item }">
                  <td>
                    <CButton color="danger" @click="
                      deleteDayId = day.id;
                    deleteRowId = item.id;
                    showDeleteRowModal = true;
                    ">
                      <CIcon name="cil-trash" /> Delete
                    </CButton>
                  </td>
                </template>
              </CDataTable>
            </CCollapse>
          </CRow>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script setup>
// @ts-check
import { getCurrentInstance, ref, computed, onMounted, reactive } from 'vue';
import axios from "axios";
import store from '@/store.js';
import { ExperienceTypesNames, SourceTypes } from '@/common.js';
import { fetchDataOrError } from '@/utils/datafetch'
import { DatePickerComponent } from '@syncfusion/ej2-vue-calendars';
import TimeSlots from '@/components/timeslots/TimeSlots.vue';
import TimeSlotsEditModal from '@/components/timeslots/TimeSlotsEditModal.vue';

/**
 * @template T
 * @typedef {import('vue').Ref<T>} Ref
 */
/** @typedef {import('@/types').TimeSlot} TimeSlot */

const instance = getCurrentInstance();
const router = instance.proxy.$router;
const route = instance.proxy.$route;

const toggleNameTranslations = ref(false);
const toggleStartingPriceTranslations = ref(false);
const partnerId = ref(localStorage.getItem("partner_id"));
const emptyGuid = "00000000-0000-0000-0000-000000000000";
const experienceId = ref("00000000-0000-0000-0000-000000000000");
const items = ref([]);

const integrations = ref([]);
const rowfields = ["name", "Source", "Resource", "Visibility", "status", "sortOrder", "Edit", "Delete"];
const showDayModal = ref(false);
const dayModalMode = ref('');
const showDeleteDayModal = ref(false);
const showDeleteRowModal = ref(false);
const externalIntegrationString = "EXTERNAL_INTEGRATION";
const deleteDayId = ref('');
const deleteRowId = ref('');
const editDayId = ref(undefined);

const languages = ref([]);
const startOfTimeslot = reactive({});
const endOfTimeslot = reactive({});
const expRowOptions = ref([]);
const chosenNewExpType = ref(null);
const selectedIntegration = ref(null);
const day = ref([]);
const itemsVisibility = reactive({});

// timeslots add/edit modal
/** @type {Ref<'none' | 'add' | 'edit'>} */
const timeSlotsEditModalMode = ref('none');
/** @type {Ref<TimeSlot | null>} */
const editTimeSlotData = ref(null);
const multiSelect = ref(null);
const selectedWeekDaysAdd = ref([]);

const BASE_URL = store.state.apiAddress;

const experienceDay = reactive({
  name: null,
  order: null,
  description: null,
  id: emptyGuid
});

const experienceSchedule = reactive({
  id: emptyGuid,
  timeSelection: 3,
  nameTranslations: [],
  startingPriceTranslations: [],
  duration: {},
  startTime: null,
  endTime: null,
  active: true,
  perDepartureCapacity: {
    minTotal: null,
    maxTotal: null,
    bookings: null,
    guestTypeSpecificCapac: [],
    disabled: true
  },
  perBookingCapacity: {
    minTotal: null,
    maxTotal: null,
    disabled: true,
    label: null,
    guestTypeSpecificCapac: []
  },
  availability: [],
  limit: {},
  bookingCutoff: {},
  concurrentCapacity: {}
});
const isDataLoaded = ref(false);

// Alert state
const alertType = ref("danger");
const message = ref(null);

// Available start days
const initialSelectedValue = false;
const selectedStartDays = ref({
  '1': initialSelectedValue,
  '2': initialSelectedValue,
  '3': initialSelectedValue,
  '4': initialSelectedValue,
  '5': initialSelectedValue,
  '6': initialSelectedValue,
  '7': initialSelectedValue,
});
const weekDayOptions = [
  { value: 1, text: 'Monday' },
  { value: 2, text: 'Tuesday' },
  { value: 3, text: 'Wednesday' },
  { value: 4, text: 'Thursday' },
  { value: 5, text: 'Friday' },
  { value: 6, text: 'Saturday' },
  { value: 7, text: 'Sunday' }
];
/** @param {string} dayStartingFromOne */
const getWeekdayName = (dayStartingFromOne) => {
  return weekDayOptions.find(day => day.value.toString() === dayStartingFromOne)?.text;
}

/**
 * @typedef {import('@/types').TimeSlotEditPayload} TimeSlotEditPayload
 * @param {{ type: 'close' | 'edit' | 'add' | 'delete', payload: TimeSlotEditPayload }} args 
 */
const changeTimeSlot = async (args) => {
  if (args && args.type && ['add', 'edit', 'delete'].includes(args.type)) {
    const type = args.type;
    let result = null;
    /** @type {import('@/types').ExperienceScheduleChangeTimeSlotPayload} */
    const callPayload = {
      ...args.payload,
      experienceScheduleId: experienceSchedule.id
    }
    if (type === 'add') {
      if (experienceSchedule.id === emptyGuid) {
        await create();
      }
      result = await fetchDataOrError(() => axios.post(`${BASE_URL}/v1/ExperienceSchedule/${experienceId.value}/AddTimeslot`, callPayload));
    }
    if (type === 'edit') {
      result = await fetchDataOrError(() => axios.put(`${BASE_URL}/v1/ExperienceSchedule/${experienceId.value}/UpdateTimeslot`, callPayload));
    } 
    if (type === 'delete') {
      result = await fetchDataOrError(() => axios.post(`${BASE_URL}/v1/ExperienceSchedule/${experienceId.value}/DeleteTimeslot`, callPayload));
    }
    if (result.success) {
      alertType.value = "success";
      message.value = "Successfully updated timeslot.";
      setTimeout(() => message.value = null, 5000);
      await get(experienceSchedule.id);
    } else {
      alertType.value = "danger";
      message.value = result.error?.response?.data?.errors ?? 'Error saving timeslots';
      setTimeout(() => message.value = null, 10000);
    }
  }
  resetTimeslotState();
  timeSlotsEditModalMode.value = 'none';
};

const appendValueAdd = (event) => {
  selectedWeekDaysAdd.value = event;
};

const openDeleteTimeSlotConfirm = () => {
  showDeleteTimeSlot.value = true;
};

const initperDepartureCapacity = (guestType) => {
  experienceSchedule.perDepartureCapacity.guestTypeSpecificCapac.push({
    disabled: false,
    min: null,
    max: null,
    bookings: null,
    guestTypeId: guestType.value,
    label: guestType.label
  });
};

const initperBookingCapacity = (guestType) => {
  experienceSchedule.perBookingCapacity.guestTypeSpecificCapac.push({
    disabled: false,
    min: null,
    max: null,
    guestTypeId: guestType.value,
    label: guestType.label
  });
};

const openAddTimeslot = () => {
  timeSlotsEditModalMode.value = 'add';
};

const addGuestTypeLabel = (guestTypeData, expRowData) => {
  const expRowGuestTypeIdx = expRowData?.findIndex(g => g.guestTypeId === guestTypeData.value);
  if (expRowGuestTypeIdx > -1) {
    const modifiedData = { ...expRowData[expRowGuestTypeIdx], label: guestTypeData.label };
    expRowData.splice(expRowGuestTypeIdx, 1, modifiedData);
  }
  return expRowGuestTypeIdx;
};

const getGuestTypes = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/v1/ListItem/GuestTypeList?partnerId=${partnerId.value}&experienceId=${experienceId.value}`);
    
    if (response && response.data) {
      const guestTypes = response.data;
      if (route.params.id !== emptyGuid) {
        if (!experienceSchedule.perDepartureCapacity.guestTypeSpecificCapac) {
          experienceSchedule.perDepartureCapacity.guestTypeSpecificCapac = [];
        }
        if (!experienceSchedule.perBookingCapacity.guestTypeSpecificCapac) {
          experienceSchedule.perBookingCapacity.guestTypeSpecificCapac = [];
        }

        for (let guestType of guestTypes) {
          const idxC = addGuestTypeLabel(guestType, experienceSchedule.perDepartureCapacity.guestTypeSpecificCapac);
          if (idxC === -1) {
            initperDepartureCapacity(guestType);
          }

          const idxCC = addGuestTypeLabel(guestType, experienceSchedule.perBookingCapacity.guestTypeSpecificCapac);
          if (idxCC === -1) {
            initperBookingCapacity(guestType);
          }
        }
      } else {
        experienceSchedule.perDepartureCapacity.guestTypeSpecificCapac = [];
        experienceSchedule.perBookingCapacity.guestTypeSpecificCapac = [];

        for (let guestType of guestTypes) {
          initperDepartureCapacity(guestType);
          initperBookingCapacity(guestType);
        }
      }
    }
  } catch (error) {
    alertType.value = "danger";
    message.value = error;
    setTimeout(() => message.value = null, 10000);
  }
};

/**
 * @param {TimeSlot} timeSlot
 * @param {'edit' | 'delete'} mode
 */
const openEditTimeslot = (timeSlot, mode = 'edit') => {
  editTimeSlotData.value = timeSlot;
  timeSlotsEditModalMode.value = mode;
};

const getVisibilityBadge = (visibility) => {
  switch (visibility) {
    case 0: return "success";
    case 1: return "secondary";
    default: return "warning";
  }
};

const getStatusBadge = (status) => {
  return status ? "success" : "secondary";
};

const toggle = (ei) => {
  itemsVisibility[ei] = !itemsVisibility[ei];
};

const closeDayModal = (status, evt, accept) => {
  if (accept) {
    addNewDay();
  }
};

const closeDeleteModal = (status, evt, accept) => {
  if (accept) {
    deleteExperienceDay(experienceDay.id);
  }
};

const deleteExperienceDay = async (id) => {
  try {
    await axios.delete(
      `${BASE_URL}/v1/ExperienceDay/${experienceSchedule.id}/${id}`
    );
    
    alertType.value = "success";
    message.value = "Successfully deleted experience day.";
    setTimeout(() => message.value = null, 5000);
    
    await getExperienceDays();
  } catch (error) {
    message.value = error;
  }
};

const createExpRowOptions = () => {
  const arr = [{ value: null, label: "Choose" }];
  for (let key of Object.keys(ExperienceTypesNames)) {
    arr.push({ value: key, label: ExperienceTypesNames[key] });
  }
  return arr;
};

const openExpRowAddModal = (id) => {
  editDayId.value = id;
};

const chooseExpType = (type) => {
  chosenNewExpType.value = type;
};

const chooseIntegration = (integrationId) => {
  selectedIntegration.value = integrationId;
};

const modalAction = (_, evt, accept) => {
  if (accept) {
    if (chosenNewExpType.value == null) return;
    addExperienceRow();
  } else {
    editDayId.value = undefined;
  }
};

const addExperienceRow = (id) => {
  const rowId = id || emptyGuid;
  router.push({ 
    path: `/experiences/schedule/day/${editDayId.value}/row/${rowId}`, 
    query: { 
      op: 'create', 
      expType: chosenNewExpType.value, 
      scheduleId: experienceSchedule.id, 
      experienceId: experienceId.value, 
      integrationType: selectedIntegration.value 
    } 
  });
  editDayId.value = undefined;
};

const editExperienceRow = (dayId, id) => {
  const rowLink = `/experiences/schedule/day/${dayId}/row/${id}`;
  const day = items.value.find(item => item.id === dayId);
  const expRow = day.experienceRows.find(row => row.id === id);
  
  router.push({ 
    path: rowLink, 
    query: { 
      op: 'edit', 
      scheduleId: experienceSchedule.id, 
      sourceType: expRow.sourceType, 
      experienceId: experienceId.value 
    } 
  });
};

const closeDeleteRowModal = (status, evt, accept) => {
  if (accept) {
    deleteExperienceRow(deleteDayId.value, deleteRowId.value);
  }
};

const deleteExperienceRow = async (experienceDayId, experienceRowId) => {
  try {
    await axios.delete(
      `${BASE_URL}/v1/ExperienceRow/${experienceDayId}/${experienceRowId}`
    );
    
    alertType.value = "success";
    message.value = "Successfully deleted experience row.";
    setTimeout(() => message.value = null, 5000);
    
    if (route.params.id !== emptyGuid) {
      await get(route.params.id);
    }
  } catch (error) {
    message.value = error;
  }
};

const addNewDay = async () => {
  try {
    await axios.post(
      `${BASE_URL}/v1/ExperienceDay/${experienceSchedule.id}`,
      experienceDay
    );
    
    alertType.value = "success";
    message.value = "Successfully added experience day.";
    setTimeout(() => message.value = null, 5000);
    
    Object.assign(experienceDay, {
      name: null,
      order: null,
      description: null,
      id: emptyGuid
    });
    
    await getExperienceDays();
  } catch (error) {
    message.value = error;
  }
};

const dayLink = (id) => `/experiences/schedule/day/${id.toString()}`;
const rowLink = (dayId, id) => `/experiences/schedule/day/${dayId.toString()}/row/${id.toString()}`;

const editDay = (id) => {
  router.push({ path: dayLink(id) });
};

const goBack = () => {
  router.go(-1);
};

const getLanguages = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/v1/PartnerLanguage`);
    languages.value = response.data;
    
    for (let language of languages.value) {
      if (!experienceSchedule.nameTranslations.find(t => t.languageCode === language.languageCode)) {
        experienceSchedule.nameTranslations.push({
          languageCode: language.languageCode,
          name: null,
          languageId: language.languageId,
        });
      }

      if (!experienceSchedule.startingPriceTranslations.find(t => t.languageCode === language.languageCode)) {
        experienceSchedule.startingPriceTranslations.push({
          languageCode: language.languageCode,
          name: null,
          languageId: language.languageId,
        });
      }
    }

    // Filter translations
    experienceSchedule.nameTranslations = experienceSchedule.nameTranslations.filter(
      translation => languages.value.find(x => x.languageCode === translation.languageCode)
    );

    experienceSchedule.startingPriceTranslations = experienceSchedule.startingPriceTranslations.filter(
      translation => languages.value.find(x => x.languageCode === translation.languageCode)
    );
  } catch (error) {
    alertType.value = "danger";
    message.value = error;
    setTimeout(() => message.value = null, 10000);
  }
};

const getExperienceDays = async () => {
  try {
    const response = await axios.get(
      `${BASE_URL}/v1/ExperienceDay/${experienceSchedule.id}`
    );
    
    items.value = response.data;
    
    for (let item of items.value) {
      itemsVisibility[item.id] = true;
      
      for (let expRow of item.experienceRows) {
        if (expRow.descriptionTranslations) {
          const english = expRow.descriptionTranslations.find(e => e.languageCode === 'en-US');
          if (english?.name) expRow.name = english.name;
        }
        expRow.source = SourceTypes[expRow.sourceType];
        if (expRow.inventory?.name) expRow.resource = expRow.inventory.name;
      }
    }
  } catch (error) {
    alertType.value = "danger";
    message.value = error;
    setTimeout(() => message.value = null, 10000);
  }
};

const selectedWeekdaysToTimeslot = () => {
  return Object.keys(selectedStartDays.value).filter(day => selectedStartDays.value[day] === true).map(selectedDay => Number(selectedDay))
}

const create = async () => {
  try {
    // Normalize values
    experienceSchedule.startTime = experienceSchedule.startTime || null;
    experienceSchedule.endTime = experienceSchedule.endTime || null;
    experienceSchedule.perDepartureCapacity.bookings = experienceSchedule.perDepartureCapacity.bookings || null;
    experienceSchedule.perDepartureCapacity.minTotal = experienceSchedule.perDepartureCapacity.minTotal || null;
    experienceSchedule.perDepartureCapacity.maxTotal = experienceSchedule.perDepartureCapacity.maxTotal || null;
    experienceSchedule.perBookingCapacity.maxTotal = experienceSchedule.perBookingCapacity.maxTotal || null;
    experienceSchedule.perBookingCapacity.minTotal = experienceSchedule.perBookingCapacity.minTotal || null;

    // Normalize capacity arrays
    experienceSchedule.perBookingCapacity.guestTypeSpecificCapac = 
      experienceSchedule.perBookingCapacity.guestTypeSpecificCapac.map(value => ({
        ...value,
        min: value.min || null,
        max: value.max || null,
        guestTypeId: value.guestTypeId
      }));

    experienceSchedule.perDepartureCapacity.guestTypeSpecificCapac = 
      experienceSchedule.perDepartureCapacity.guestTypeSpecificCapac.map(value => ({
        ...value,
        min: value.min || null,
        max: value.max || null,
        guestTypeId: value.guestTypeId
      }));
    
    if (experienceSchedule.timeSelection !== 1) {
      experienceSchedule.availability[0].days = selectedWeekdaysToTimeslot();
    }

    const response = await axios.post(
      `${BASE_URL}/v1/ExperienceSchedule/${experienceId.value}`,
      experienceSchedule
    );

    alertType.value = "success";
    message.value = "Successfully updated experience schedule.";
    setTimeout(() => message.value = null, 5000);
    
    experienceSchedule.id = response.data;
    return response;

  } catch (error) {
    alertType.value = "danger";
    message.value = error.response?.data.errors || error.message;
    setTimeout(() => message.value = null, 10000);
    throw error;
  }
};

const getAllIntegrations = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/v1/PartnerIntegration/list`);
    integrations.value = response.data;
  } catch (error) {
    alertType.value = "danger";
    message.value = error;
    setTimeout(() => message.value = null, 10000);
  }
};

const get = async (id) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/v1/experienceSchedule/${experienceId.value}/${id}`
    );
    
    Object.assign(experienceSchedule, response.data);

    // Initialize missing objects
    if (!experienceSchedule.bookingCutoff) {
      experienceSchedule.bookingCutoff = { days: 0, hours: 0, minutes: 0 };
    }
    if (!experienceSchedule.nameTranslations) {
      experienceSchedule.nameTranslations = [];
    }
    if (!experienceSchedule.startingPriceTranslations) {
      experienceSchedule.startingPriceTranslations = [];
    }
    if (!experienceSchedule.duration) {
      experienceSchedule.duration = { days: 0, hours: 0, minutes: 0 };
    }
    if (!experienceSchedule.limit) {
      experienceSchedule.limit = { minDays: 0, maxDays: 0 };
    }
    if (!experienceSchedule.concurrentCapacity) {
      experienceSchedule.concurrentCapacity = { minGuests: 0, maxGuests: 0, bookings: 0 };
    }
    if (!experienceSchedule.perBookingCapacity) {
      experienceSchedule.perBookingCapacity = {};
    }
    if (!experienceSchedule.perDepartureCapacity) {
      experienceSchedule.perDepartureCapacity = {};
    }

    // Convert dates
    if (experienceSchedule.startTime) {
      experienceSchedule.startTime = new Date(experienceSchedule.startTime);
    }
    if (experienceSchedule.endTime) {
      experienceSchedule.endTime = new Date(experienceSchedule.endTime);
    }

    if (experienceSchedule.timeSelection !== 1) {
      const storedStartDays = experienceSchedule.availability[0].days;
      for (const selectedWeekday of storedStartDays) {
        selectedStartDays.value[selectedWeekday.toString()] = true;
      }
    }

    await getExperienceDays();
    await getLanguages();

  } catch (error) {
    alertType.value = "danger";
    message.value = error.data;
    setTimeout(() => message.value = null, 10000);
  } finally {
    isDataLoaded.value = true;
  }
};

// Helper functions
const resetTimeslotState = () => {
  editTimeSlotData.value = null;
  multiSelect.value?.clearSelection();
};

// Lifecycle hooks
onMounted(async () => {
  expRowOptions.value = createExpRowOptions();
  await getAllIntegrations();
  experienceId.value = route.params.experienceId;
  await get(route.params.id);
  await getGuestTypes();
});
</script>
